export default function PageNumber({ pagination, loading, handlePageChange }) {
    return (
        Array.from(
            { length: pagination.last_page },
            (_, index) => index + 1
        ).map((page) => (
            <button
                key={page}
                onClick={() => handlePageChange(page)}
                disabled={
                    loading ||
                    page === pagination.current_page
                }
                className={
                    page === pagination.current_page
                        ? "active"
                        : ""
                }
            >
                {page}
            </button>
        ))
    );
}